import React, { useEffect } from "react";
import { setTzurPopupCenter } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import "./TzurPopupCenter.scoped.scss"

const TzurPopupCenter = () => {
    const { state, dispatch } = useStore();
    const { tzurPopupCenter } = state;
    const { isOpen, Component, note, closingAction } = tzurPopupCenter;

    const resetScrollPosition = () => {
        document.body.style.overflow = "auto";
    }

    useEffect(() => {
        if (isOpen === false) {
            resetScrollPosition();
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    const close = (e, shouldCallClosingAction) => {

        e.preventDefault();
        shouldCallClosingAction && typeof (closingAction) === "function" && closingAction();
        resetScrollPosition();
        dispatch(setTzurPopupCenter({ isOpen: false }));
    };

    return (
        <div className="popup" id="tempArea" aria-hidden="false">
            <div className="popupFlex">
                <div className="popupFrame">
                    <div className="popupFrame_close"><a href="/" onClick={close} aria-label="חלונית אזור חדש - לחץ לסגירה" role="button" aria-controls="tempArea"><i role="img" aria-hidden="true" className="icon-close"></i></a></div>
                    {Component}
                    {note}
                </div>
            </div>
        </div>
    );
}

export default TzurPopupCenter;

export const openTzurPopupCenter = (dispatch, Title, Component, note) => {
    dispatch(setTzurPopupCenter({
        isOpen: true,
        Title,
        Component,
        note
    }));
};

